import { Api } from '../api';
import { messages } from '../endpoints';
import type { GetMessagesResponse, SendMessageRequest } from './models';

export class MessagesApi extends Api {
  static getMessages = (type: 'incomming' | 'outgoing', signal?: AbortSignal) =>
    this.get<GetMessagesResponse[]>({ url: messages.getMessages(type), signal });

  static getNewMessagesInfo = (lastPing: string = '1900-01-01T00:00:00Z', signal?: AbortSignal) =>
    this.get({ url: messages.getNewMessagesInfo(), queryParams: { lastPing }, signal });

  static markAsRead = (messageId: string, signal?: AbortSignal) => this.put({ url: messages.markAsRead(messageId), signal });

  static sendMessage = (data: SendMessageRequest, signal?: AbortSignal) =>
    this.post<SendMessageRequest>({ url: messages.sendMessage(), data, signal });
}
